<cds-modal size="sm" *ngIf="deleteFileModalOpen" [open]="deleteFileModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Delete File
		</h3>
	</cds-modal-header>
	<section cdsModalContent [hasForm]="true">
		<h1 *ngIf="filePendingDeletion['File Name']" cdsModalContentText class="cds--modal-content__regular-content modal-text">
			Are you sure you want to delete {{filePendingDeletion['File Name']}}?
		</h1>
	</section>
	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="this.deleteFileModalOpen = false">
			Cancel
		</button>
		<button class="cds--btn cds--btn--danger" (click)="deleteFile()">
			Delete
		</button>
	</cds-modal-footer>
</cds-modal>
